/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Audio_Recorder_Init_FailedInputs */

const en_audio_recorder_init_failed = /** @type {(inputs: Audio_Recorder_Init_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to initialize audio recorder: ${i?.error}`)
};

const fr_audio_recorder_init_failed = /** @type {(inputs: Audio_Recorder_Init_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Échec de l'initialisation de l'enregistreur audio : ${i?.error}`)
};

const de_audio_recorder_init_failed = /** @type {(inputs: Audio_Recorder_Init_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fehler beim Initialisieren des Audiorecorders: ${i?.error}`)
};

const it_audio_recorder_init_failed = /** @type {(inputs: Audio_Recorder_Init_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile inizializzare il registratore audio: ${i?.error}`)
};

const ru_audio_recorder_init_failed = /** @type {(inputs: Audio_Recorder_Init_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось инициализировать аудиорекордер: ${i?.error}`)
};

const es_audio_recorder_init_failed = /** @type {(inputs: Audio_Recorder_Init_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error al inicializar la grabadora de audio: ${i?.error}`)
};

const zh_cn2_audio_recorder_init_failed = /** @type {(inputs: Audio_Recorder_Init_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`音频录制器初始化失败：${i?.error}`)
};

const ja_audio_recorder_init_failed = /** @type {(inputs: Audio_Recorder_Init_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`オーディオレコーダーの初期化に失敗しました: ${i?.error}`)
};

const hi_audio_recorder_init_failed = /** @type {(inputs: Audio_Recorder_Init_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ऑडियो रिकॉर्डर को प्रारंभ करने में विफल: ${i?.error}`)
};

const pt_pt2_audio_recorder_init_failed = /** @type {(inputs: Audio_Recorder_Init_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha ao inicializar o gravador de áudio: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Failed to initialize audio recorder: {error}" |
*
* @param {Audio_Recorder_Init_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_init_failed = /** @type {((inputs: Audio_Recorder_Init_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_Init_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_recorder_init_failed(inputs)
	if (locale === "de") return de_audio_recorder_init_failed(inputs)
	if (locale === "it") return it_audio_recorder_init_failed(inputs)
	if (locale === "ru") return ru_audio_recorder_init_failed(inputs)
	if (locale === "es") return es_audio_recorder_init_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_recorder_init_failed(inputs)
	if (locale === "ja") return ja_audio_recorder_init_failed(inputs)
	if (locale === "hi") return hi_audio_recorder_init_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_recorder_init_failed(inputs)
	return en_audio_recorder_init_failed(inputs)
});